import {
  BottomSheet,
  Illustration,
  Text,
  Title,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

export interface UpdateEtaNudgeBottomSheetProps {
  modalState: UseModalState;
  onUpdateEta: () => void;
  onCancelShift: () => void;
}

export function UpdateEtaNudgeBottomSheet(props: UpdateEtaNudgeBottomSheetProps) {
  const { modalState, onUpdateEta, onCancelShift } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth size="large" variant="contained" onClick={onUpdateEta}>
            Update ETA
          </Button>
          <Button fullWidth size="large" variant="outlined" onClick={onCancelShift}>
            Cancel Shift
          </Button>
        </DialogFooter>
      }
      paperSx={{
        paddingBottom: 8,
      }}
    >
      <DialogContent sx={{ textAlign: "center" }}>
        <Stack direction="column" alignItems="center" spacing={6} px={6}>
          <Illustration type="driving-error" />
          <Title variant="h3" component="h3">
            Are you still showing up for your shift?
          </Title>
          <Text variant="body1">
            If you intend to arrive, update your ETA as soon as possible. Otherwise, you should
            cancel the shift.
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
